/**
 * Google Tag Manager, loaded only when REACT_APP_GTM_ID is set — i.e. in
 * production builds (.env.production). QA builds leave it unset (build:qa
 * clears it), so the QA site sends nothing to the production container.
 * Replaces the static snippet that used to live in public/index.html; the
 * no-JS <noscript> fallback is added to the built HTML by scripts/gtm-noscript.mjs.
 */
export function loadGtm(id: string | undefined): void {
  if (!id || typeof window === 'undefined') return;
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);
  // No noscript fallback here: a noscript created from JavaScript is not inert, so its iframe would
  // load a second container path in every JS-enabled visit. The parser-created fallback is injected
  // into the built HTML by scripts/gtm-noscript.mjs, production builds only.
}
